import Dashboard from "../pages/dashboard";
import Category from "../pages/category";
import AddCategory from "../pages/category/add";
import SubCategory from "../pages/subcategory";
import AddSubCategory from "../pages/subcategory/add";
import Grade from "../pages/grade";
import City from "../pages/city";
import AddCity from "../pages/city/add";
import State from "../pages/state";
import AddState from "../pages/state/add";
import Country from "../pages/country";
import AddCountry from "../pages/country/add";
import AddGrade from "../pages/grade/add";
import Party from "../pages/party";
import AddParty from "../pages/party/add";
import Product from "../pages/product";
import AddProduct from "../pages/product/add";
import SubProduct from "../pages/subproduct";
import AddSubProduct from "../pages/subproduct/add";
import AddInvoice from "../pages/sales/add";
import AddInvoices from "../pages/invoice/add";
import Invoices from "../pages/invoice";
import Perfoma from "../pages/sales/perfoma";
import AddPerfoma from "../pages/sales/addPerfoma";
import Banks from "../pages/banks";
import AddBanks from "../pages/banks/add";
import Profile from "../pages/settings/profile";
import Pdf from "../shared/pdf";
import AddCredit from "../pages/notes/addCredit";
import CreditNotes from "../pages/notes/creditNote";
import Transport from "../pages/transport";
import AddTransport from "../pages/transport/add";
import Payment from "../pages/payment";
import AddPayment from "../pages/payment/add";
import Size from "../pages/size";
import AddSize from "../pages/size/add";
import Series from "../pages/series";
import AddSeries from "../pages/series/add";
import Posts from "../pages/posts";
import AddPosts from "../pages/posts/add";
import Catalogue from "../pages/catalogue";
import AddCatalogue from "../pages/catalogue/add";
import SearchLedger from '../pages/ledger/search';
import SearchOutStanding from '../pages/outstanding/search';
import SearchLedgerByDay from '../pages/outstanding/searchLedgerByDay';
import Notification from '../pages/notification/notification';

const AdminRoutes = [
  { path: "", component: <Dashboard /> },
  { path: "dashboard", component: <Dashboard /> },
  { path: "category", component: <Category /> },
  { path: "category/add", component: <AddCategory /> },
  { path: "category/edit/:id", component: <AddCategory /> },
  { path: "subcategory", component: <SubCategory /> },
  { path: "subcategory/add", component: <AddSubCategory /> },
  { path: "subcategory/edit/:id", component: <AddSubCategory /> },
  { path: "party", component: <Party /> },
  { path: "party/add", component: <AddParty /> },
  { path: "party/edit/:id", component: <AddParty /> },
  { path: "product", component: <Product /> },
  { path: "product/add", component: <AddProduct /> },
  { path: "product/edit/:id", component: <AddProduct /> },
  { path: "subproduct", component: <SubProduct /> },
  { path: "subproduct/add", component: <AddSubProduct /> },
  { path: "subproduct/edit/:id", component: <AddSubProduct /> },
  { path: "grade", component: <Grade /> },
  { path: "grade/add", component: <AddGrade /> },
  { path: "grade/edit/:id", component: <AddGrade /> },
  { path: "city", component: <City /> },
  { path: "city/add", component: <AddCity /> },
  { path: "city/edit/:id", component: <AddCity /> },
  { path: "state", component: <State /> },
  { path: "state/add", component: <AddState /> },
  { path: "state/edit/:id", component: <AddState /> },
  { path: "country", component: <Country /> },
  { path: "country/add", component: <AddCountry /> },
  { path: "country/edit/:id", component: <AddCountry /> },
  { path: "transport", component: <Transport /> },
  { path: "transport/add", component: <AddTransport /> },
  { path: "transport/edit/:id", component: <AddTransport /> },
  { path: "banks", component: <Banks /> },
  { path: "banks/add", component: <AddBanks /> },
  { path: "banks/edit/:id", component: <AddBanks /> },
  { path: "invoice", component: <Invoices /> },
  { path: "invoice/add", component: <AddInvoices /> },
  { path: "invoice/edit/:id", component: <AddInvoices /> },
  { path: "invoice/view/:id", component: <Pdf /> },
  { path: "payment", component: <Payment /> },
  { path: "payment/add", component: <AddPayment /> },
  { path: "payment/edit/:id", component: <AddPayment /> },
  { path: 'ledger', component: <SearchLedger /> },
  { path: 'ledger-day-wise', component: <SearchLedgerByDay /> },
  { path: 'outstanding', component: <SearchOutStanding /> },
  { path: "perfoma", component: <Perfoma /> },
  { path: "add-perfoma", component: <AddPerfoma /> },
  { path: "add-invoice", component: <AddInvoice /> },
  { path: "sales-return", component: <CreditNotes /> },
  { path: "sales-return/add", component: <AddCredit /> },
  { path: "sales-return/edit/:id", component: <AddCredit /> },
  { path: "size", component: <Size /> },
  { path: "size/add", component: <AddSize /> },
  { path: "size/edit/:id", component: <AddSize /> },
  { path: "series", component: <Series /> },
  { path: "series/add", component: <AddSeries /> },
  { path: "series/edit/:id", component: <AddSeries /> },
  { path: "catalogue", component: <Catalogue /> },
  { path: "catalogue/add", component: <AddCatalogue /> },
  { path: "catalogue/edit/:id", component: <AddCatalogue /> },
  { path: "posts", component: <Posts /> },
  { path: "posts/add", component: <AddPosts /> },
  { path: "posts/edit/:id", component: <AddPosts /> },
  { path: "profile", component: <Profile /> },
  { path: "notification", component: <Notification /> },
];

export default AdminRoutes;
